import { render } from "./ReportsTabs.vue?vue&type=template&id=477d71ce"
import script from "./ReportsTabs.vue?vue&type=script&lang=js"
export * from "./ReportsTabs.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__